/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingExpenseLedger from './accounting-expense-ledger';
import AccountingExpenseLedgerDetail from './accounting-expense-ledger-detail';
import AccountingExpenseLedgerUpdate from './accounting-expense-ledger-update';
import AccountingExpenseLedgerDeleteDialog from './accounting-expense-ledger-delete-dialog';

const AccountingExpenseLedgerRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingExpenseLedger />} />
    <Route path="new" element={<AccountingExpenseLedgerUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingExpenseLedgerDetail />} />
      <Route path="edit" element={<AccountingExpenseLedgerUpdate />} />
      <Route path="delete" element={<AccountingExpenseLedgerDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingExpenseLedgerRoutes;
